import { TipoRegistroInstrumentoFinanceiro } from "./genericTypes";

/*
  Relação de Campos que podem ou não ser Aditados - Segundo a Área de Controles Internos
  - true: campo desabilitado
  - false: campo habilitado
*/
export const fieldDisabledConfig = {
  emissor: true,
  numeroEmissao: true,
  numeroSerie: true,
  tipoSerie: true,
  ufLocalEmissao: true,
  localEmissao: true,
  ufLocalPagamento: true,
  localPagamento: true,
  tipoLiquidacao: false,
  bancoLiquidanteEmissor: false,
  numeroAgenciaContaCorrenteVinculadaEmissao: false,
  numeroContaCorrenteVinculadaEmissao: false,
  chaveExterna: false,
  escriturador: false,
  descricaoAdicional: false,
  semGarantia: false,
  fidejussoria: false,
  garantiaReal: false,
  valorNominalUnitarioEmissao: false,
  volumeEmissao: false,
  dataEmissao: true,
  quantidadeEmitida: false,
  dataLimiteIntegralizacao: false,
  quandoInicioRentabilidade: false,
  dataInicioRentabilidade: false,
  indexador: false,
  taxaJurosFixoSpread: false,
  convencao: false,
  custoTotal: false,
  feeLaqusBruto: true,
  feeLaqusLiquido: true,
  feeRepasse: false,
  percentualAmortizacaoSobre: false,
  percentualAmortizacaoPassivelAlteracao: false,
  amortizacoes: false,
  novoPagamentoJuros: false,
  dataIncorporacaoJuros: false,
  apresentaResgateAntecipadoFacultativo: false,
};

export const useFieldDisabledConfig = (typeOfRegister: TipoRegistroInstrumentoFinanceiro) => {
  if (typeOfRegister === TipoRegistroInstrumentoFinanceiro.Aditamento) {
    return fieldDisabledConfig;
  }

  return Object.fromEntries(
    Object.keys(fieldDisabledConfig).map(key => [key, false])
  ) as typeof fieldDisabledConfig;
};
